import type { LicenseRow, StateLoginRow } from '../../types/onboarding'
import { companyNameOptions } from './businessEntityNames'

/** Whether the row counts as done for SL Logins Continue (deferred counts as done there). */
export function loginRowCompleteForPrimaryStep(
  row: StateLoginRow,
  licenses: LicenseRow[],
): boolean {
  if (row.illinoisPendingChoice) return false
  if (row.miscManaged) return true
  if (row.pendingLoginWizard) return true
  if (!(row.username.trim().length > 0 && row.password.trim().length > 0)) return false
  const opts = companyNameOptions(licenses, [])
  if (opts.length <= 1) return true
  const c = (row.clientCompanyName ?? '').trim()
  return c.length > 0
}

/** Deferred rows on New Login Wizard: credentials + client when multiple business entities exist. */
export function loginRowCompleteForNewLoginWizard(
  row: StateLoginRow,
  licenses: LicenseRow[],
): boolean {
  if (row.miscManaged) return true
  if (!(row.username.trim().length > 0 && row.password.trim().length > 0)) return false
  const opts = companyNameOptions(licenses, [])
  if (opts.length <= 1) return true
  const c = (row.clientCompanyName ?? '').trim()
  return c.length > 0
}
